<nz-card *ngIf="details$ | async as details" class="position-fixed card">
  <nz-spin
    [nzSpinning]="selectedVariantQuantityChangePending$ | async"
    [nzIndicator]="loadingIndicatorTemplate"
  >
    <leap-product-cart-form-generic-details
      *ngIf="selectedVariant"
      [profile]="profile"
      [product]="product"
      [selectedVariant]="selectedVariant"
      [expiringContract]="expiringContract"
      [details]="details"
      [isProductBundle]="isProductBundle"
      [isPromotionPricingApplied]="
        selectedVariant?.pricing?.isPromotionPricingApplied
      "
      [actualBasePrice]="
        selectedVariant?.pricing?.actualBasePrice | number: '1.2-2'
      "
      [promotionPricingDiscountEndDate]="
        selectedVariant?.pricing?.promotionPricingDetail
          ?.promotionPricingDiscountEndDate
      "
      [currencySign]="
        (currencySignsMap$ | async)?.get(selectedVariant?.pricing?.currency)
      "
      [basePrice]="selectedVariant?.pricing?.basePrice | number: '1.2-2'"
      [surchargeTotalAmount]="
        selectedVariant?.pricing?.surchargeTotalAmount | number: '1.2-2'
      "
      [licenseForm]="(licenseForm$ | async).model"
    ></leap-product-cart-form-generic-details>

    <div *leapHasGroup="['buyer']">
      <div class="quantity">
        Quantity:
        <input
          name="quantity"
          nz-input
          type="number"
          min="1"
          (ngModelChange)="quantityInputSubject.next()"
          [(ngModel)]="quantity"
        />
      </div>
      <p class="description" *ngIf="product.type === 'Exam'">
        Tip: You need one exam per participant
      </p>
    </div>
    <ng-container *ngIf="isLogged$ | async; else notLoggedInTemplate">
      <ng-container
        *ngIf="
          !profile?.employee?.account?.buyer;
          else productRestrictionTemplate
        "
      >
        <ng-container
          *ngTemplateOutlet="notBuyerWarningTemplate"
        ></ng-container>
      </ng-container>
    </ng-container>
    <div *leapHasGroup="['buyer']">
      <button
        nz-button
        [nzLoading]="requestEvaluationCopyPending"
        nzType="default"
        *ngIf="
          (isLogged$ | async) &&
          selectedVariant?.delivery?.evaluationCopyAvailable
        "
        (click)="requestEvaluationCopy()"
      >
        Request Free Evaluation Copy
      </button>
    </div>
  </nz-spin>
</nz-card>

<nz-modal
  *ngIf="isLogged$ | async"
  nzWidth="1000"
  [nzTitle]="null"
  [nzMaskClosable]="false"
  [nzFooter]="null"
  [nzVisible]="showAddToOrderTemplateModal"
  (nzOnCancel)="hideAddToOrderTemplateOptions()"
>
  <leap-product-add-order-templates
    [profile]="profile"
    [product]="product"
    [selectedVariant]="selectedVariant"
    [expiringContract]="expiringContract"
    [details]="details$ | async"
    (onProductQuantityChange)="productQuantityChangeForOrderTemplates($event)"
    [orderTemplatePricing]="orderTemplatePricing$ | async"
    (onModalClose)="hideAddToOrderTemplateOptions()"
    [currencySign]="
      (currencySignsMap$ | async)?.get(selectedVariant?.pricing?.currency)
    "
    [basePrice]="selectedVariant.pricing.basePrice | number: '1.2-2'"
    [surchargeTotalAmount]="
      selectedVariant.pricing.surchargeTotalAmount | number: '1.2-2'
    "
  ></leap-product-add-order-templates>
</nz-modal>

<ng-template #haveAccessTemplate>
  <button
    nz-button
    nzType="primary"
    [nzLoading]="addLineItemPending$ | async"
    [disabled]="
      (addLineItemPending$ | async) ||
      product.restriction.isNotContractedSupplier
    "
    (click)="addToCart()"
  >
    Add to Cart
  </button>
  <nz-divider></nz-divider>
  <button
    nz-button
    nzType="default"
    class="no-margin-top"
    *ngIf="canBePublishedToLxp$ | async"
    (click)="product?.publishedToLxp ? editLxpProduct() : publsihToLxp()"
    [disabled]="product?.publishedToLxp || isProductBundle"
  >
    Publish To LXP
  </button>
  <button nz-button nzType="default" (click)="showAddToOrderTemplateOptions()">
    Add to Order Template
  </button>
  <!-- <div class="subscription-plans">
        <div class="col-left">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.2" overflow="visible" preserveAspectRatio="none" viewBox="0 0 642 514" xml:space="preserve" y="0px" x="0px" id="Layer_1_1556011678242" width="26" height="23"><g transform="translate(1, 1)"><path d="M85.7,373.4c9.7,0,17.5-7.8,17.5-17.5V178.3c0-3.1,2.5-5.6,5.6-5.6h53.6v179.2c0,13.2,10.8,24,24,24h254  c13.2,0,24-10.8,24-24V172.7h67c0.1,0,2.3,0,3.9,1.6c0.6,0.6,1.6,1.9,1.6,3.9v177.6c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5  V178.3c0-10.8-4.2-21-11.9-28.7c-10.7-10.7-23.6-11.9-28.7-11.9h-67v-23.8h40c13.3,0,24-10.7,24-24v-40c0-26.5-21.5-48-48-48h-294  c-13.2,0-24,10.8-24,24v111.8h-53.6c-22.4,0-40.6,18.2-40.6,40.6v177.6C68.2,365.6,76,373.4,85.7,373.4z M464.3,49.9  c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v32h-32V49.9z M194.3,33.9H435c-1.8,5.1-2.7,10.5-2.7,16v294h-238V33.9z" vector-effect="non-scaling-stroke" style="fill: rgb(56, 182, 160);"/><path
                    d="M624,398h-48h-32H391.1c-4.1,0-7,3.1-7.9,7.1c-3.2,14.3-16,24.9-31.2,24.9h-64c-15.2,0-28-10.7-31.2-24.9  c-0.9-4-3.9-7.1-7.9-7.1H96H64H16c-8.8,0-16,7.2-16,16v18c0,44.1,35.9,80,80,80h480c44.1,0,80-35.9,80-80v-18  C640,405.2,632.8,398,624,398z M608,432c0,26.5-21.5,48-48,48H80c-26.5,0-48-21.5-48-48v-2h194.8c6.6,18.6,24.4,32,45.2,32h96  c20.9,0,38.7-13.4,45.2-32H608V432z"
                    vector-effect="non-scaling-stroke" style="fill: rgb(56, 182, 160);"/><path
                    d="M342.5,182.5l-48.3-13.5c-6.8-1.9-11.6-8.1-11.6-15c0-8.6,7.2-15.6,16.1-15.6h30.2c6.8,0,13.3,2.1,18.7,6.2  c3.3,2.5,7.9,2.2,10.9-0.8l7.6-7.7c1.7-1.7,2.6-4,2.4-6.4c-0.1-2.4-1.3-4.7-3.2-6.1c-10.4-8.3-23-12.7-36.5-12.7h-0.4V86.9  c0-4.6-3.8-8.4-8.4-8.4h-10.7c-4.6,0-8.4,3.8-8.4,8.4v23.8h-2.2c-24,0-43.6,19.3-43.6,43.1c0,19.1,13,36.2,31.6,41.4l48.3,13.5  c6.8,1.9,11.6,8.1,11.6,15c0,8.6-7.2,15.6-16.1,15.6h-30.2c-6.8,0-13.3-2.1-18.7-6.2c-3.3-2.5-7.9-2.2-10.9,0.8l-7.6,7.7  c-1.7,1.7-2.6,4-2.4,6.4c0.1,2.4,1.3,4.7,3.2,6.1c10.4,8.3,23,12.7,36.5,12.7h0.5v23.8c0,4.6,3.8,8.4,8.4,8.4H320  c4.6,0,8.4-3.8,8.4-8.4V267h2.2c24,0,43.6-19.3,43.6-43.1C374.1,204.8,361.1,187.7,342.5,182.5z"
                    vector-effect="non-scaling-stroke" style="fill: rgb(56, 182, 160);"/></g></svg>
        </div>
        <div class="col-right">
            <span> Subscription plans</span>
            <span>This product is part of one or more subscription plans.</span>
            <a href="">Learn more</a>
        </div>
    </div> -->
</ng-template>

<ng-template #noAccessTemplate>
  <ng-container>
    <div style="width: 100%; margin-top: 10px;"></div>
    <leap-expiring-contract-alert
      *ngIf="expiringContract?.expiryDate"
      [templateId]="expiringContract.template?.id"
      [expiryDate]="expiringContract.expiryDate"
    ></leap-expiring-contract-alert>
  </ng-container>
  <button
    class="primary-secondary"
    style="min-width: 274px"
    nz-button
    nzType="primary"
    (click)="goToHowToAccess()"
  >
    Get Access
  </button>
</ng-template>

<ng-template #notLoggedInTemplate>
  <nz-alert
    class="info"
    nzType="info"
    [nzDescription]="notLoggedInMessageTemplate"
  ></nz-alert>
</ng-template>

<ng-template #notLoggedInMessageTemplate>
  <span>Please <a [routerLink]="['/login']">Sign In</a> to be able to purchase</span>
</ng-template>

<ng-template #loadingIndicatorTemplate>
  <i nz-icon nzType="loading" style="font-size: 24px;"></i>
</ng-template>

<ng-template #productRestrictionTemplate>
  <!--    <ng-container *ngIf="product?.restriction?.restricted && !product?.restriction?.hasAccess && !product?.restriction?.isNotContractedSupplier; else haveAccessTemplate">-->
  <!--        <ng-container *ngTemplateOutlet="noAccessTemplate"></ng-container>-->
  <!--    </ng-container>-->
  <ng-container *ngIf="!addToBasketDisabled; else noAccessTemplate">
    <ng-container *ngTemplateOutlet="haveAccessTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #notBuyerWarningTemplate>
  <nz-alert
    class="info"
    nzType="info"
    [nzDescription]="notBuyerWarningMessageTemplate"
  ></nz-alert>
</ng-template>

<ng-template #notBuyerWarningMessageTemplate>
  <div>
    Pricing available for Buyers only.<br />
    For more information contact
    <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a
    >.
  </div>
</ng-template>
